module.exports = __webpack_public_path__ + "img/info-circle.90cb8436.svg";